import { SxProps, Theme } from "@mui/material";

export const getMSFilterSliderInputSx = (
  isSmallSize: boolean,
): SxProps<Theme> => ({
  height: "32px",
  ".MuiInput-root": {
    borderBottom: "none !important",
    "&:before": {
      bottom: "5px",
      borderBottom: "none !important",
    },
    "&:after": {
      bottom: "5px",
      borderBottom: "none !important",
    },
  },
  ".MuiInput-root input": {
    width: "100% !important",
    padding: 0,
    fontWeight: 700,
    fontSize: isSmallSize ? "11px" : "14px",
    textAlign: "center",
  },
});
